var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","color":"white"}},[_c('div',[_vm._v(" "+_vm._s(_vm.date)+" "),_c('br'),_vm._v(" ("+_vm._s(_vm.day)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }